<script>
  // @ts-check

  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;

  /** The list of radio buttons to display
   * @type {Array<{label: string; value: string}>} */
  export let options;

  /** The name of the radio button group
   * @type {string} */
  export let name;

  /** The value of the selected radio button
   * @type {string} */
  export let selection = options[0].value;

  /** The function to call when the selected radio button changes
   * @type {import("svelte/elements").ChangeEventHandler<HTMLInputElement>} */
  export let onChange;

  /**
   * An optional CSS class to be applied to the component.
   * @type {string}
   */
  export let componentClass = "";

  const inputBeforeClass =
    "before:absolute before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:h-[10px] before:w-[10px] before:bg-black before:rounded-full before:transition-opacity";
</script>

<div {id} role="radiogroup" class="flex w-full flex-col gap-3 {componentClass}">
  {#each options as { value, label }, _ (`${name}-${label}-${value}`)}
    <label
      class="inline-block cursor-pointer focus-within:outline-dashed focus-within:outline-2 focus-within:outline-offset-4 focus-within:outline-black"
    >
      <div class="flex items-center">
        <input
          {value}
          type="radio"
          {name}
          checked={selection === value}
          on:change={onChange}
          class="radius-0 relative h-6 w-6 shrink-0 cursor-pointer appearance-none bg-transparent {inputBeforeClass} {selection ===
          value
            ? 'before:opacity-[1]'
            : 'before:opacity-[0]'} rounded-full border-thin border-black outline-none hover:border-[2px]"
        />
        <span class="label ml-3">{label}</span>
      </div>
    </label>
  {/each}
</div>
